import { render, staticRenderFns } from "./SelectOptionViewKid.vue?vue&type=template&id=7390f356&scoped=true"
import script from "./SelectOptionViewKid.vue?vue&type=script&lang=js"
export * from "./SelectOptionViewKid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7390f356",
  null
  
)

export default component.exports